export default __webpack_public_path__ + "locales/lv/Settings.json?hash=ed8525a521a5864d7209c42b9580d8a4";